'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = editorIdReducer;

var _editorConstants = require('../editorConstants');

var initialState = null;

/**
 * Stores a map of measurements of target IDs.
 */
// Constants
function editorIdReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _editorConstants.EDITOR_STATE_CHANGED:
            return action.editorId;
        default:
            return state;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/store/reducers/editorIdReducer.js
// module id = 1750
// module chunks = 0